import styled from "styled-components";
import {
	FONT_WT_HEAVY,
	FONT_SIZE_26,
	MOBILE_L_BP,
} from "@website-builder/utilities-index";

export const Header = styled.h2`
	font-weight: ${FONT_WT_HEAVY};
	font-size: ${FONT_SIZE_26};
	line-height: 33px;
	text-align: center;
	margin: 26px 0;
	& .name-wrapper {
		display: flex;
		justify-content: center;
		gap: 6px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 18px;
		line-height: 23px;
		margin: 0;
	}
`;
